import React, { ReactElement, useId } from "react";
import styles from "./toggle.module.scss";

export const Toggle = (
  props: React.InputHTMLAttributes<HTMLInputElement>,
): ReactElement => {
  const localid = useId();
  const { id, ...rest } = props;

  return (
    <>
      <input
        type="checkbox"
        {...rest}
        className={styles.checkbox}
        id={id || localid}
      />
      <label htmlFor={id || localid} className={styles.label}></label>
    </>
  );
};
